export const siteWidth = 1440;

export const contentMaxWidthUtil = {
    maxWidth: siteWidth,
    margin: '0px auto',
};

export const heroHeight = 500;
export const heroWidth = 3000;
